import { useContext } from "@wordpress/element";
import placeholderImageUrl from '../../../../includes/assets/img/profile-image.png';
import icons from '../../../options/icons';
import BlockContext from '../context/blockContext';


function HeaderTwo() {
	const { attributes } = useContext(BlockContext);
	const { profileImage, socialIcon } = attributes;
  return (
    <div>
      <>
        <div className="profile-img">
            <img
                src={profileImage?.url || placeholderImageUrl}
                alt={profileImage?.alt || "Profile Image"}
        />
        </div>
        <div className="profile-info">
        <div className="social-icon">
          {socialIcon?.map((item, index) => (
            item.link ? (
              <a key={index} href={item.link} target="_blank" rel="noopener noreferrer">
                <span className="icon">{icons[item.icon]}</span>
              </a>
            ) : (
              <span key={index} className="icon disabled">
                {icons[item.icon]}
              </span>
            )
          ))}
        </div>
        </div>
    </>
    </div>
  )
}

export default HeaderTwo
